var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.classes(),attrs:{"loading":!_vm.noLazy ? 'lazy' : 'eager',"srcSet":_vm.getRatios().join(','),"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }